import { MHTTPCL } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const CustomTextService = {
  findTemplates: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    output: 'json'
  }).then(res => res.data),
  findTemplatesByTemplateKey: (template_key = '') => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    output: 'json',
    template_key,
  }).then(res => res.data),
  findArtistTemplates: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    template_key: 'offer_mail_to_artist',
    output: 'json',
  }).then(res => res.data),
  findMailTemplates: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    template_key: 'request_form_mail',
    output: 'json',
  }).then(res => res.data),
  findQuestionnaireTemplates: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    template_key: 'promoter_questionnaire_mail',
    output: 'json',
  }).then(res => res.data),
  findDocumentTemplates: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    template_key: 'booking_document_and_files',
    output: 'json',
  }).then(res => res.data),
  findAssistantIntelligence: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    group_prefix: 'ai',
    output: 'json',
  }).then(res => res.data),

  findTemplateDetails: ({
    template_id
  }) => MHTTPCL.post(SETTINGS_URL, {
    section: 'templates',
    template_id,
  }).then(res => res.data),
}